{{custom-wizard-date-time-input
  date=this.dateTime
  onChange=(action "onChange")
  tabindex=this.field.tabindex
}}